import { Locale } from 'components/core/locale/types';

export const AccountCreateTranslations = {
  [Locale.English]: {
    AccountCreate: {
      pageTitle: 'Account Creation',
      pageTitleCoreCare: 'Caregiver Account',
      formCoreCareTitle: 'Please verify your information below is accurate:',
      createAccountCta: 'Continue',
      welcomeHeader: 'Welcome to Bend Health!',
      welcomeLine1: "We are so glad you're here.",
      Components: {
        Account: {
          Form: {
            parentGuardianHeader: `{isAdultMemberAllowed, select,
              true{Finish Setting Up Your Account}
              false{Parent/Guardian Information}
              other{}
            }`,
            firstNameLabel: 'My First Name',
            lastNameLabel: 'My Last Name',
            birthDateLabel: 'My Birth Date',
            phoneNumberLabel: 'My Phone Number',
            emailLabel: 'My Email',
            insuranceCarrierLabel: 'Current Insurance Provider',
            otherInsuranceLabel: 'Other insurance',
          },
        },
      },
    },
  },
};
